import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetMessagesLogRequest,
  GetMessagesLogResponse,
  GlobalWhatsAppContactsRequest,
  GlobalWhatsAppContactsResponse,
  SendMessageRequest,
  SendMessageResponse,
} from "../../models/WhatsApp.model";
const API_BASE_URL = environment.apiUrl;

export const SendMessage = createAsyncThunk<
  SendMessageResponse,
  SendMessageRequest,
  { rejectValue: string }
>("whatsapp/SendMessage", async (requestData, { rejectWithValue }) => {
  try {
    // תמיד שולח FormData, גם בלי קובץ
    const formData = new FormData();
    formData.append("Token", requestData.token ?? "");
    formData.append("CompanyKey", requestData.companyKey ?? "");
    formData.append("Message", requestData.message ?? "");
    formData.append("PhoneNumber", requestData.phoneNumber ?? "");
    if (requestData.media) formData.append("Media", requestData.media);
    if (requestData.mediaType)
      formData.append("MediaType", requestData.mediaType);

    const response = await fetch(`${API_BASE_URL}WhatsApp/SendMessage`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: SendMessageResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to send text message");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const GetMessagesLog = createAsyncThunk<
  GetMessagesLogResponse,
  GetMessagesLogRequest,
  { rejectValue: string }
>("whatsapp/GetMessagesLog", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}WhatsApp/GetMessagesLog`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetMessagesLogResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch messages log");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const globalWhatsAppContacts = createAsyncThunk<
  GlobalWhatsAppContactsResponse,
  GlobalWhatsAppContactsRequest,
  { rejectValue: string }
>("whatsapp/GlobalWhatsAppContacts", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}WhatsApp/GlobalWhatsAppContacts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GlobalWhatsAppContactsResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch messages log");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
